var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgStack = ({
  title,
  titleId,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 800,
  height: 800,
  viewBox: "0 0 32 32",
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M8.984 9.047V6.031h19v13.953h-3.016l.062 3.031h-3.078v2.953H3.016V12h2.969V8.984zM26.953 7h-17v2.047l15.078-.062-.062 10.031h1.984zM24 10.016H6.953V12h15v9.984H24zM3.984 12.969V25h17V12.969z"
})));
export { SvgStack as ReactComponent };
export default __webpack_public_path__ + "assets/images/stack.svg";